module.exports = require('./helpers/bundle-url').getBundleURL('HeG8V') + "logo.c51670a8.svg";